module.exports = __webpack_public_path__ + "media/images/newsbg-d0929abf1406593fa754d2eb7023e6a0.png";